import { ASSET_MANAGEMENT_GET_FORM_DATA, ASSET_MANAGEMENT_GET_BY_ID, FORMLIST_ADD_DATA, FORMLIST_UPDATE_DATA, FORMLIST_GET_BY_ID, FORMLIST_UPDATE_STATUS } from './Constants'

const initialState = {
    loading: false,
    error: null,
    assetFormData: [],
    assetFormDataById: null,
    formDataById: null,
    addSuccess: false,
    updateSuccess: false,
    statusUpdateSuccess: false,
}

const Reducer = (state = initialState, action) => {
    switch (action.type) {

        case ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                assetFormData: []
            }
        case ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                assetFormData: action.data
            }
        case ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }

        case ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                assetFormDataById: []
            }
        case ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                assetFormDataById: action.data
            }
        case ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                formDataById: null
            }
        case FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                formDataById: action.data
            }
        case FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }    
        case FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                addSuccess: false
            }
        case FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                addSuccess: true
            }
        case FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                addSuccess: false
            }

        case FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                updateSuccess: false
            }
        case FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                updateSuccess: true
            }
        case FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                updateSuccess: false
            }  
        case FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
                statusUpdateSuccess: false
            }
        case FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                statusUpdateSuccess: true
            }
        case FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                statusUpdateSuccess: false
            }    
             

        default:
            return {
                ...state,
            }
    }
}

export default Reducer;